import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ListItem } from '../repository/listRepository';
import { NotesEditor } from './NotesEditor';

interface ItemRowProps {
  item: ListItem;
  rank?: number;
  showDragHandle?: boolean;
  onDelete: () => void;
  onUpdate: (updates: Partial<ListItem>) => void;
}

export const ItemRow: React.FC<ItemRowProps> = ({ item, rank, showDragHandle, onDelete, onUpdate }) => {
  const [editingTitle, setEditingTitle] = useState(false);
  const [editingNotes, setEditingNotes] = useState(false);
  const [title, setTitle] = useState(item.title);
  const [notes, setNotes] = useState(item.notes);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.uuid });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleTitleBlur = () => {
    setEditingTitle(false);
    if (title !== item.title) {
      onUpdate({ title });
    }
  };

  const handleNotesBlur = () => {
    setEditingNotes(false);
    if (notes !== item.notes) {
      onUpdate({ notes });
    }
  };

  const handleTitleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      (e.target as HTMLInputElement).blur();
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`item-row${isDragging ? ' dragging' : ''}`}
    >
      {showDragHandle && (
        <span className="drag-handle" {...attributes} {...listeners}>&#x2630;</span>
      )}
      {rank !== undefined && <span className="item-rank">{rank}.</span>}
      <div className="item-content">
        {editingTitle ? (
          <input
            className="item-title-input"
            value={title}
            onChange={e => setTitle(e.target.value)}
            onBlur={handleTitleBlur}
            onKeyDown={handleTitleKeyDown}
            autoFocus
          />
        ) : (
          <span className="item-title" onClick={() => setEditingTitle(true)}>{item.title}</span>
        )}
        {editingNotes ? (
          <NotesEditor
            value={notes}
            onChange={setNotes}
            onBlur={handleNotesBlur}
            autoFocus
          />
        ) : (
          item.notes ? (
            <div className="item-notes" onClick={() => setEditingNotes(true)}>{item.notes}</div>
          ) : (
            <div className="item-notes" onClick={() => setEditingNotes(true)} style={{ fontStyle: 'italic' }}>
              Add notes...
            </div>
          )
        )}
      </div>
      <div className="item-actions">
        <button onClick={onDelete} className="btn btn-sm btn-danger">x</button>
      </div>
    </div>
  );
};
